import React               from 'react';
import { Redirect }        from 'react-router-dom';
import ScheduledCourseList from './ScheduledCourseList';
import ScheduledCourse     from './ScheduledCourse';

export const ScheduledCourseConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes  : [
        {
            path      : '/scheduled_course/list',
            component : ScheduledCourseList,
            permission: { component_name: 'scheduled_course', permission_type: 'list' },
        },
        {
            path      : '/scheduled_course/:view_type/:scheduled_course_id',
            component : ScheduledCourse,
            permission: { component_name: 'scheduled_course', permission_type: 'view_type' },
        },
        {
            path      : '/scheduled_course/:view_type/',
            component : ScheduledCourse,
            permission: { component_name: 'scheduled_course', permission_type: 'view_type' },
        },
        {
            path      : '/scheduled_course',
            component : () => <Redirect to="/scheduled_course/list" />,
            permission: { component_name: 'scheduled_course', permission_type: 'list' },
        }
    ]
};



// WEBPACK FOOTER //
// src/main/content/scheduled_course/ScheduledCourseConfig.js